import { all } from 'redux-saga/effects'

//admin
import adminAuthSaga from '../admin/redux/auth/saga'
import adminSettingSaga from '../admin/redux/settings/saga'
import providerManagementSaga from '../admin/redux/providerManagement/saga'
import adminCMSSaga from '../admin/redux/cms/saga'
import adminManageStore from '../admin/redux/manageStore/saga'
import adminManageOrderSaga from '../admin/redux/orderManagement/saga'
import adminOtherSaga from '../admin/redux/other/saga'

//main
import userAuthSaga from '../main/redux/auth/saga'
import AdminMarketPlaceSaga from '../admin/redux/marketplace/saga'
import AdminServiceSaga from '../admin/redux/adminServices/saga'
import AdminJobSaga from '../admin/redux/jobManagement/saga'
import AdminHealthCareSaga from '../admin/redux/healthcareManagement/saga'
import gigManagementSaga from '../admin/redux/gigManagement/saga'
// Event Management
import EventSaga from '../admin/redux/eventManagement/saga'

//ambulance
import mainAuthSaga from '../main/redux/auth/saga'
//Vehicle Management
import vehicleManagementSaga from '../admin/redux/vehicleManagement/saga'
//Feedback Management
import feedbackManagementSaga from '../admin/redux/feedbackManagement/saga'
//Book a Cab
import bookCabSaga from '../main/redux/bookCab/saga'
//Tutor Management
import tutorManagementSaga from '../admin/redux/tutorManagement/saga'

export default function* rootSaga() {
  yield all([
    adminAuthSaga(),
    adminSettingSaga(),
    adminManageOrderSaga(),
    adminOtherSaga(),
    providerManagementSaga(),
    adminCMSSaga(),
    mainAuthSaga(),
    AdminMarketPlaceSaga(),
    adminManageStore(),
    userAuthSaga(),
    AdminServiceSaga(),
    AdminJobSaga(),
    AdminHealthCareSaga(),
    EventSaga(),
    gigManagementSaga(),
    vehicleManagementSaga(),
    feedbackManagementSaga(),
    bookCabSaga(),
    tutorManagementSaga(),
  ])
}
